import { useState } from "react";
import { Spinner } from "react-bootstrap";
import Can from "../../../permissions/Can";
import { PERMISSIONS } from "../../../permissions/permissions";
import { useReportTemplateContext } from "../ReportTemplate/ReportTemplateContext";
import { giveUserAccessToKiinteisto } from "../../utils/userPermissions";
import { useParams } from "react-router-dom";

const ROLES = [
  { key: "koordinaattori",    label: "Koordinaattori" },
  { key: "kuntotutkija",      label: "Kuntotutkija" },
  { key: "rakennustekniikka", label: "Rakennustekniikka" },
  { key: "lvia",              label: "LVIA-järjestelmät" },
  { key: "sahko",             label: "Sähköjärjestelmät" },
];

export default function KayttajalisaysReport() {
  const { allUsers = [], assignments = {}, addUserToSystem, removeUserFromSystem, usersLoading } = useReportTemplateContext();
  const { id: kiinteistoId } = useParams();
  const [selectedUsers, setSelectedUsers] = useState({});

  if (usersLoading) return <Spinner animation="border" size="sm" />;

  const handleAdd = async (key, userId) => {
    if (!userId) return;
    addUserToSystem(key, Number(userId));
    try { await giveUserAccessToKiinteisto(Number(userId), Number(kiinteistoId)); } catch {}
    setSelectedUsers(prev => ({ ...prev, [key]: "" }));
  };

  return (
    <Can permission={PERMISSIONS.REPORTS.ASSIGN_REPORT_MAKER} mode="disable">
      <div className="border rounded overflow-hidden" style={{ fontSize: '0.95rem' }}>
        {ROLES.map(({ key, label }, i) => {
          const assigned = assignments[key] || [];
          const available = allUsers.filter(u => !assigned.some(a => a.id === u.id));
          return (
            <div
              key={key}
              className="d-flex align-items-center gap-2 px-3 py-2"
              style={{ borderTop: i > 0 ? '1px solid #e9ecef' : 'none', minHeight: 44 }}
            >
              {/* Role label */}
              <div className="flex-shrink-0 text-muted fw-semibold" style={{ minWidth: 160 }}>
                {label}
              </div>

              {/* Assigned user chips */}
              <div className="d-flex flex-wrap gap-1 flex-grow-1">
                {assigned.length === 0 && (
                  <span className="text-muted" style={{ fontSize: '0.78rem' }}>–</span>
                )}
                {assigned.map(u => (
                  <span
                    key={u.uniqueId || u.id}
                    className="badge d-flex align-items-center gap-1"
                    style={{ background: '#1a6b3c', color: '#fff', fontWeight: 600, fontSize: '0.85rem', padding: '4px 10px' }}
                  >
                    {u.nimi || u.sahkoposti}
                    <button
                      type="button"
                      className="btn-close"
                      style={{ fontSize: '0.5rem', filter: 'invert(1)' }}
                      onClick={() => removeUserFromSystem(key, u.id)}
                    />
                  </span>
                ))}
              </div>

              {/* Add dropdown */}
              {available.length > 0 && (
                <select
                  className="form-select form-select-sm flex-shrink-0"
                  style={{ width: 'auto', maxWidth: 180, fontSize: '0.78rem' }}
                  value={selectedUsers[key] || ""}
                  onChange={e => handleAdd(key, e.target.value)}
                >
                  <option value="">+ Lisää</option>
                  {available.map(u => (
                    <option key={u.id} value={u.id}>{u.nimi || u.sahkoposti}</option>
                  ))}
                </select>
              )}
            </div>
          );
        })}
      </div>
    </Can>
  );
}
